import { render, staticRenderFns } from "./TaskTemplateDropdownField.vue?vue&type=template&id=583065e4"
import script from "./TaskTemplateDropdownField.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskTemplateDropdownField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583065e4')) {
      api.createRecord('583065e4', component.options)
    } else {
      api.reload('583065e4', component.options)
    }
    module.hot.accept("./TaskTemplateDropdownField.vue?vue&type=template&id=583065e4", function () {
      api.rerender('583065e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/TaskTemplateDropdownField.vue"
export default component.exports